import { LeftOutlined, PlusOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Spin } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { organizationsApi } from "../api/organizations.api";
import {
	type OrganizationStatusFilter,
	OrganizationsFilters,
} from "../components/OrganizationsFilters";
import { OrganizationsTable } from "../components/OrganizationsTable";

export function OrganizationsPage() {
	const navigate = useNavigate();
	const location = useLocation();
	const fromDashboard = (location.state as any)?.fromDashboard === true;
	const [searchQuery, setSearchQuery] = useState("");
	const [statusFilter, setStatusFilter] = useState<OrganizationStatusFilter>("all");

	const { data: organizations = [], isLoading } = useQuery({
		queryKey: ["organizations", searchQuery, statusFilter],
		queryFn: () =>
			organizationsApi.getOrganizations({
				isActive: statusFilter === "all" ? undefined : statusFilter === "active" ? "true" : "false",
				search: searchQuery.trim() || undefined,
			}),
	});

	return (
		<div className="crm-organizations">
			<div className="crm-page-head">
				<div>
					<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
						{fromDashboard && (
							<Button
								type="text"
								icon={<LeftOutlined />}
								onClick={() => navigate("/dashboard")}
								style={{ color: "var(--crm-text-secondary)" }}
							/>
						)}
						<h1>Tashkilotlar</h1>
					</div>
					<p>
						{fromDashboard ? (
							<span style={{ color: "var(--crm-text-secondary)" }}>Bosh sahifa / </span>
						) : null}
						Tizimda ro'yxatdan o'tgan kompaniyalar
					</p>
				</div>
				<Button
					className="crm-primary-btn"
					icon={<PlusOutlined />}
					onClick={() => navigate("/organizations/new")}
				>
					Yangi tashkilot
				</Button>
			</div>

			<OrganizationsFilters
				onSearchChange={setSearchQuery}
				onStatusChange={setStatusFilter}
				searchValue={searchQuery}
				statusValue={statusFilter}
			/>
			{isLoading ? (
				<div style={{ padding: 60, textAlign: "center" }}>
					<Spin size="large" />
				</div>
			) : (
				<OrganizationsTable
					onOpenOrganization={(organization) => navigate(`/organizations/${organization.id}`)}
					organizations={organizations}
				/>
			)}
		</div>
	);
}
